// Permission: array of strings, e.g., ["operator"], ["analyst"], ["operator", "analyst"] (OR logic)
export const ALL_LINKS = [
  {
    name: "統計數據",
    icon: "chart-simple",
    path: "/analytics",
    permission: ["operator", "analyst"], // operator OR analyst
  },
  {
    name: "影片審核",
    icon: "eye",
    path: "/review/videos",
    permission: ["operator", "analyst"], // operator OR analyst
  },
  {
    name: "貼文審核",
    icon: "file-text",
    path: "/review/posts",
    permission: ["operator"], // operator only
  },
  {
    name: "聊天",
    icon: "comments",
    path: "/chats",
    permission: ["operator", "analyst"], // operator OR analyst
  },
  {
    name: "公告管理",
    icon: "megaphone",
    path: "/announcements",
    permission: ["operator"], // operator only
  },
  {
    name: "探索頁面管理",
    icon: "compass",
    path: "/explore",
    permission: ["analyst", "operator"], // operator OR analyst
  },
  {
    name: "創作者管理",
    icon: "pen",
    path: "/creators",
    permission: ["operator"], // operator only
  },
  {
    name: "使用者查詢",
    icon: "users",
    path: "/users/search",
    permission: ["operator"], // operator only
  },
  {
    name: "儲值查詢",
    icon: "users",
    path: "/deposits/search",
    permission: ["operator"], // operator only
  },
  {
    name: "鑽石交易紀錄查詢",
    icon: "gem",
    path: "/transactions/search",
    permission: ["operator"], // operator only
  },
  {
    name: "自動追蹤設定",
    icon: "user-plus",
    path: "/auto-follow",
    permission: ["operator"], // operator only
  },
  {
    name: "短影音推薦設定",
    icon: "video",
    path: "/short-videos",
    permission: ["operator"], // operator only
  },
  {
    name: "每月主播結算",
    icon: "chart-line",
    path: "/points-summary",
    permission: ["operator", "analyst"], // operator OR analyst
  },
  // Hidden routes (not in sidebar but need permission control)
  {
    path: "/guest-mode",
    permission: ["operator"],
    hidden: true,
  },
  {
    path: "/developer",
    permission: ["operator"],
    hidden: true,
  },
  {
    path: "/pre-registration-reward/claim",
    permission: ["operator"],
    hidden: true,
  },
  {
    path: "/earnings",
    permission: ["operator"],
    hidden: true,
  },
];

export const getPermissionByPath = (path) => {
  const link = ALL_LINKS.find((l) => l.path === path);
  return link ? link.permission : ["operator"]; // default to operator only
};
